import styled from 'styled-components'

export const FormGroup = styled.div`
  box-sizing: border-box;
  line-height: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
`
